// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-dealer-balloon {
  /* Colors */
  --perxis-auto-dealer-balloon-background-color-inner: var(--perxis-auto-dealer-balloon-background-color, var(--perxis-auto-root-first-color-inner));
  background-color: var(--perxis-auto-dealer-balloon-background-color-inner);
}

.perxis-auto-1_16_0-dealer-balloon-title {
  /* Typography */
  --perxis-auto-dealer-balloon-title-font-family-inner: var(--perxis-auto-dealer-balloon-title-font-family, var(--perxis-auto-root-typography-main-font-family-inner));
  --perxis-auto-dealer-balloon-title-font-size-inner: var(--perxis-auto-dealer-balloon-title-font-size-xs, 18px);
  --perxis-auto-dealer-balloon-title-font-weight-inner: var(--perxis-auto-dealer-balloon-title-font-weight, 700);
  --perxis-auto-dealer-balloon-title-letter-spacing-inner: var(--perxis-auto-dealer-balloon-title-letter-spacing, var(--perxis-auto-root-typography-main-letter-spacing-inner));
  --perxis-auto-dealer-balloon-title-line-height-inner: var(--perxis-auto-dealer-balloon-title-line-height, 1.2);
  --perxis-auto-dealer-balloon-title-text-transform-inner: var(--perxis-auto-dealer-balloon-title-text-transform, var(--perxis-auto-root-typography-main-text-transform-inner));
  --perxis-auto-dealer-balloon-title-color-inner: var(--perxis-auto-dealer-balloon-title-color, var(--perxis-auto-root-typography-color-darkest-inner));
  /* End Typography */
  --perxis-auto-typography-main-font-family: var(--perxis-auto-dealer-balloon-title-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-dealer-balloon-title-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-dealer-balloon-title-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-dealer-balloon-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-balloon-title-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-dealer-balloon-title-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-dealer-balloon-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-dealer-balloon-title-line-height-inner);
}
@media (min-width: 576px) {
  .perxis-auto-1_16_0-dealer-balloon-title {
    --perxis-auto-dealer-balloon-title-font-size-inner: var(--perxis-auto-dealer-balloon-title-font-size, 16px);
  }
}

.perxis-auto-1_16_0-dealer-balloon-address {
  /* Typography */
  --perxis-auto-dealer-balloon-address-font-family-inner: var(--perxis-auto-dealer-balloon-address-font-family, var(--perxis-auto-root-typography-small-font-family-inner));
  --perxis-auto-dealer-balloon-address-font-size-inner: var(--perxis-auto-dealer-balloon-address-font-size, 14px);
  --perxis-auto-dealer-balloon-address-font-weight-inner: var(--perxis-auto-dealer-balloon-address-font-weight, var(--perxis-auto-root-typography-small-font-weight-inner));
  --perxis-auto-dealer-balloon-address-letter-spacing-inner: var(--perxis-auto-dealer-balloon-address-letter-spacing, var(--perxis-auto-root-typography-small-letter-spacing-inner));
  --perxis-auto-dealer-balloon-address-line-height-inner: var(--perxis-auto-dealer-balloon-address-line-height, 1.5);
  --perxis-auto-dealer-balloon-address-text-transform-inner: var(--perxis-auto-dealer-balloon-address-text-transform, var(--perxis-auto-root-typography-small-text-transform-inner));
  --perxis-auto-dealer-balloon-address-color-inner: var(--perxis-auto-dealer-balloon-address-color, var(--perxis-auto-root-typography-color-dark-inner));
  /* End Typography */
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-balloon-address-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-balloon-address-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-balloon-address-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-balloon-address-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-dealer-balloon-address-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-balloon-address-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-balloon-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-balloon-address-line-height-inner);
}

.perxis-auto-1_16_0-dealer-balloon-phone {
  /* Typography */
  --perxis-auto-dealer-balloon-phone-font-family-inner: var(--perxis-auto-dealer-balloon-phone-font-family, var(--perxis-auto-root-typography-small-font-family-inner));
  --perxis-auto-dealer-balloon-phone-font-size-inner: var(--perxis-auto-dealer-balloon-phone-font-size, var(--perxis-auto-root-typography-small-font-size-xxl-inner));
  --perxis-auto-dealer-balloon-phone-font-weight-inner: var(--perxis-auto-dealer-balloon-phone-font-weight, var(--perxis-auto-root-typography-small-font-weight-inner));
  --perxis-auto-dealer-balloon-phone-letter-spacing-inner: var(--perxis-auto-dealer-balloon-phone-letter-spacing, var(--perxis-auto-root-typography-small-letter-spacing-inner));
  --perxis-auto-dealer-balloon-phone-line-height-inner: var(--perxis-auto-dealer-balloon-phone-line-height, 1.5);
  --perxis-auto-dealer-balloon-phone-text-transform-inner: var(--perxis-auto-dealer-balloon-phone-text-transform, var(--perxis-auto-root-typography-small-text-transform-inner));
  --perxis-auto-dealer-balloon-phone-color-inner: var(--perxis-auto-dealer-balloon-phone-color, var(--perxis-auto-root-typography-color-darkest-inner));
  /* End Typography */
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-balloon-phone-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-balloon-phone-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-balloon-phone-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-balloon-phone-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-balloon-phone-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-balloon-phone-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-balloon-phone-line-height-inner);
}

.perxis-auto-1_16_0-dealer-balloon-tags {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}
.perxis-auto-1_16_0-dealer-balloon-tags--overflow::after {
  content: "";
  position: absolute;
  right: 0;
  width: 20px;
  height: 100%;
  background: linear-gradient(270deg, var(--perxis-auto-dealer-balloon-background-color-inner) 25%, rgba(255, 255, 255, 0) 100%);
}

.perxis-auto-1_16_0-dealer-balloon-forward {
  /* Typography */
  --perxis-auto-dealer-balloon-forward-icon-size-inner: var(--perxis-auto-dealer-balloon-forward-icon-size, 24px);
  /* End Typography */
  /* Colors */
  --perxis-auto-dealer-balloon-forward-icon-color-inner: var(--perxis-auto-dealer-balloon-forward-icon-color, var(--perxis-auto-root-second-color-inner));
  /* End Colors */
  --perxis-auto-button-text-icon-color: var(--perxis-auto-dealer-balloon-forward-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-balloon-forward-icon-size-inner);
}

.perxis-auto-1_16_0-dealer-balloon-buttons {
  /* Sizes */
  --perxis-auto-dealer-balloon-buttons-offset-inner: var(--perxis-auto-dealer-balloon-buttons-offset, 18px);
  --perxis-auto-dealer-balloon-buttons-gap-inner: var(--perxis-auto-dealer-balloon-buttons-gap, 12px);
  /* End Sizes */
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: calc(100% + var(--perxis-auto-dealer-balloon-buttons-offset-inner) * 2);
  left: calc(var(--perxis-auto-dealer-balloon-buttons-offset-inner) * -1);
  overflow-x: auto;
  scrollbar-width: none;
}
.perxis-auto-1_16_0-dealer-balloon-buttons::-webkit-scrollbar {
  display: none;
}
.perxis-auto-1_16_0-dealer-balloon-buttons > .perxis-auto-1_16_0-dealer-balloon-buttons__button.perxis-auto-1_16_0-button.ant-5_17_0-btn {
  flex: 0;
  margin-right: var(--perxis-auto-dealer-balloon-buttons-gap-inner);
}
.perxis-auto-1_16_0-dealer-balloon-buttons > .perxis-auto-1_16_0-dealer-balloon-buttons__button.perxis-auto-1_16_0-button.ant-5_17_0-btn:first-child {
  margin-left: var(--perxis-auto-dealer-balloon-buttons-offset-inner);
}
.perxis-auto-1_16_0-dealer-balloon-buttons > .perxis-auto-1_16_0-dealer-balloon-buttons__button.perxis-auto-1_16_0-button.ant-5_17_0-btn:last-child {
  margin-right: var(--perxis-auto-dealer-balloon-buttons-offset-inner);
}

.perxis-auto-1_16_0-dealer-balloon-close {
  /* Typography */
  --perxis-auto-dealer-balloon-close-icon-size-inner: var(--perxis-auto-dealer-balloon-close-icon-size, 18px);
  /* End Typography */
  /* Colors */
  --perxis-auto-dealer-balloon-close-icon-color-inner: var(--perxis-auto-dealer-balloon-close-icon-color, var(--perxis-auto-root-fourth-color-inner));
  /* End Colors */
  --perxis-auto-button-text-icon-color: var(--perxis-auto-dealer-balloon-close-icon-color-inner);
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-balloon-close-icon-size-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
